export const environment = {
  env: "U.A.T",
  msal:{
    clientId: '1a0f0268-62ea-48d8-be1b-92a74d0cdb37',
  },
  mercury:{
    api:{
      username:"CCISE@chill.ie",
      password: "&hKRW6aZjx_5aP&!",
      address: 'https://uat-mercury.chill.ie'
    }, 
    function:{
      address: "https://mercuryfunctions-uat.chill.ie/api",
      code: "DDOgaw2fZmxj5Uy/NIenNuEfgrIMSaqgsSi2baInI1xNb6Z1ncn7Ug==" 
    },
    heca:{
      address: 'https://heca-se.chill.ie/api'
    }

  }

};
